import { ListOfficerActionResult } from '../models/list-officer-action-result.models';
import { Officer, OfficerForOrganizationChart } from '../models/list-officer.models';

export const LIST_OFFICER_STORE_KEY = 'list-officer';

export interface IListOfficerState {
  officers: Officer[];
  orgChartOfficers: OfficerForOrganizationChart[];
  paginationOfficers: Officer[];
  actionResult: ListOfficerActionResult | null;
  filteredOfficersTotalCount: number;
  query: string;
  isLoading: boolean;
}

export const initialState: IListOfficerState = {
  officers: [],
  orgChartOfficers: [],
  paginationOfficers: [],
  actionResult: null,
  filteredOfficersTotalCount: 0,
  query: '',
  isLoading: false,
};
